module.exports = __webpack_public_path__ + "img/drag-handle.06015dc9.svg";